import { FundsRequestStatus } from 'enums';

export const WITHDRAWAL_FEE_AMOUNT = 2; //usdt todo: get from metadata
export const MAX_WITHDRAWAL_FEE_AMOUNT = 100;

export const FUNDS_REQUEST_TRANSACTION_IN_PROGRESS_STATUSES = [
  FundsRequestStatus.WaitingTransaction,
];
